(function () {
  const filterGridWrapper = document.querySelector("[data-filter-grid-js]");
  const filterGridCells = document.querySelectorAll(
    "[data-filter-grid-js] .filter-grid__cell",
  );

  if (filterGridWrapper) {
    filterGridCells.forEach((filterGrid) => {
      const filterGridBtn = filterGrid.querySelector("button");
      filterGridBtn.addEventListener("click", () => {
        const filterGridValue = filterGridBtn.dataset.filterValue;
        const filterTrigger = document.querySelector(
          `.filter-item__content[data-value="${filterGridValue}"]`,
        );
        // Trigger click to apply filters
        filterTrigger.click();
      });
    });
  }

  const addClearAllEvent = () => {
    const clearAllBtn = document.querySelector(
      ".collection-top-bar__clear-all",
    );
    if (clearAllBtn) {
      const sectionsInstances = Shopify.theme.sections.instances;
      const resultsInstance = sectionsInstances.find(
        (instance) =>
          instance.container.classList.contains("collection") ||
          instance.container.classList.contains("search"),
      );
      clearAllBtn.addEventListener("click", () => {
        const searchWrapper = document.querySelector(".search");
        if (searchWrapper) {
          const urlParams = new URLSearchParams(window.location.search);
          const searchQuery = urlParams.get("q");
          resultsInstance.__renderView(`q=${searchQuery}`);
        } else {
          resultsInstance.__renderView("");
        }

        // Reset mobile filters as well
        const allFilterOptions = document.querySelectorAll(
          '.collection-modal .filter-item__content input[type="checkbox"], .collection-sidebar__filters .filter-item__content input[type="checkbox"]',
        );
        allFilterOptions.forEach(
          (filterOption) => (filterOption.checked = false),
        );
      });
    }
  };

  window.addEventListener("DOMContentLoaded", () => {
    addClearAllEvent();
  });

  const onUrlChange = () => {
    const newUrl = location.href;
    if (newUrl !== currentUrl) {
      currentUrl = newUrl;

      const queryParamsArray = getQueryParams();

      // Update filter grids
      if (filterGridCells) {
        filterGridCells.forEach((filterGridCell) => {
          const isInQueryParams = queryParamsArray.some((queryParam) => {
            const filterGridBtn = filterGridCell.querySelector("button");
            const filterGridName = filterGridBtn.dataset.filterParam;
            const filterGridValue = filterGridBtn.dataset.filterValue;

            return (
              queryParam.name === filterGridName &&
              queryParam.value === filterGridValue
            );
          });

          if (isInQueryParams) {
            filterGridCell.classList.add("active");
          } else {
            filterGridCell.classList.remove("active");
          }
        });
      }

      // Update product count
      const totalCountElement = document.querySelector(
        ".collection-sidebar__total-products",
      );
      totalCountElement.innerText = `${Shopify.resultsData.totalProducts} ${window.location.href.includes("/search") ? "results" : "products"}`;
      const searchHeading = document.querySelector(
        ".main-search .page__heading",
      );
      if (searchHeading) {
        searchHeading.innerText = `${Shopify.resultsData.totalProducts} results for “${Shopify.resultsData.terms}“`;
      }

      // Update filter values quantities
      const filters = Shopify.resultsData.filters.filter(
        (filter) => filter.type === "list" || filter.type === "boolean",
      );
      filters.forEach((filter) => {
        const filterValues = filter.values;
        filterValues.forEach((filterValue) => {
          const matchedItemElements = Array.from(
            document.querySelectorAll(
              `.filter-item__content[data-value="${filterValue.value}"]`,
            ),
          );
          if (matchedItemElements.length > 0) {
            matchedItemElements.forEach((item) => {
              // Toggle disabled class based on products count
              if (filterValue.count === 0) {
                item.classList.add("filter-item__content--disabled");
              } else {
                item.classList.remove("filter-item__content--disabled");
              }
              const labelElement = item.querySelector(".filter-item__label");
              if (labelElement) {
                labelElement.innerText = `${filterValue.label} (${filterValue.count})`;
              }
            });
          }
        });
      });

      addClearAllEvent();
    }
  };

  // Sync grid state with theme native filters
  let currentUrl = location.href;

  const observer = new MutationObserver(onUrlChange);
  const config = {
    target: document,
    childList: true,
    subtree: true,
  };
  observer.observe(document, config);

  const getQueryParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    // Array of query parameters
    const queryParamsArray = [];
    for (const [name, value] of urlParams.entries()) {
      queryParamsArray.push({ name, value });
    }
    return queryParamsArray;
  };

  const toQueryString = (params) => {
    return params
      .map((param) => {
        const { name, value } = param;
        const encodedValue = value ? `=${encodeURIComponent(value)}` : "";
        return `${name}${encodedValue}`;
      })
      .join("&"); // Join the resulting strings with '&'
  };

  const updateFilterCount = (filterWrapper) => {
    const checkedOptionsLength = Array.from(
      filterWrapper.querySelectorAll(
        '.filter-item input[type="checkbox"]:checked',
      ),
    ).length;
    const countLabel = filterWrapper.querySelector(
      ".collection-sidebar__filter-selected",
    );
    countLabel.innerText = `${checkedOptionsLength} selected`;
  };

  // Reset filter buttons
  const resetBtns = document.querySelectorAll(".collection-sidebar__reset");
  resetBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const sectionsInstances = Shopify.theme.sections.instances;
      const resultsInstance = sectionsInstances.find(
        (instance) =>
          instance.container.classList.contains("collection") ||
          instance.container.classList.contains("search"),
      );
      if (resultsInstance) {
        const filterWrapper = btn.closest(
          ".collection-sidebar__filter-values-wrapper",
        );
        const priceRange = btn.closest("[data-price-range]");
        let queryString = "";
        if (priceRange) {
          const newQueryParams = getQueryParams().filter(
            (param) =>
              param.name !== "filter.v.price.gte" &&
              param.name !== "filter.v.price.lte",
          );
          queryString = toQueryString(newQueryParams);
        } else {
          const checkedQueryParams = Array.from(
            filterWrapper.querySelectorAll("input[type='checkbox']:checked"),
          ).map((option) => {
            option.checked = false;
            return {
              name: option.getAttribute("name"),
              value: option.dataset.valueEscaped,
            };
          });

          const currentQueryParams = getQueryParams();
          const newQueryParams = currentQueryParams.filter((param) => {
            const isChecked = checkedQueryParams.some(
              (queryParam) => queryParam.name === param.name,
            );
            return !isChecked;
          });

          queryString = toQueryString(newQueryParams);
          updateFilterCount(filterWrapper);
        }
        // Update filters
        resultsInstance.__renderView(queryString);
      }
    });
  });

  // Sort by label change
  const sortByOptions = document.querySelectorAll(
    'input[type="radio"][name="sort_by"]',
  );
  sortByOptions.forEach((option) => {
    option.addEventListener("change", (event) => {
      if (event.target.checked) {
        const optionWrapper = event.target.closest(".filter-item");
        const optionLabel = optionWrapper
          .querySelector(".filter-item__label")
          .innerText.trim();

        // Update sort by label
        const sortByLabel = document.querySelector(
          '[data-group="Sort"] [data-sidebar-title]',
        );
        sortByLabel.innerText = optionLabel;
      }
    });
  });

  // Filter list count
  const filtersWrappers = document.querySelectorAll(
    ".collection-sidebar__filter-values-wrapper",
  );
  filtersWrappers.forEach((wrapper) => {
    const filterOptions = wrapper.querySelectorAll(
      '.filter-item input[type="checkbox"]',
    );
    filterOptions.forEach((option) => {
      option.addEventListener("change", () => {
        updateFilterCount(wrapper);
      });
    });
  });
})();
